'use client'

import { BottomNavigationVisibilityProvider } from '@widgets/bottom-navigation-with-condition'
import { ReactNode } from 'react'

export const BottomNavigationVisibilityProviderWrapper = ({
  children,
  initialValue = true,
}: {
  children: ReactNode
  initialValue?: boolean
}) => {
  return <BottomNavigationVisibilityProvider initialValue={initialValue}>{children}</BottomNavigationVisibilityProvider>
}
